export default {
    bind(el, binding) {
        el.dataset.hintposition = binding.value;
    }
};
